import { Directive, HostListener } from '@angular/core';
import { MatOption } from '@angular/material';

@Directive({
  selector: 'mat-option'
})
export class SelectOptionDirective {

  constructor(private matOption: MatOption) { }

  @HostListener('mouseover') onMouseOver() {
    this.matOption.setActiveStyles();
  }

  @HostListener('mouseout') onMouseOut() {
    this.matOption.setInactiveStyles();
  }
}